import { fmsDotUrl } from "../../helpers/urls";

export const defaultSorted = [{ dataField: "date", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    searchKey: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "date",
  pageNumber: 1,
  pageSize: 10
};

export const generateQueryParamsStrings = (filter) => {
  const arrayQueryParams = [];
  filter.startDate && arrayQueryParams.push(`StartDate=${filter.startDate}`);
  filter.endDate && arrayQueryParams.push(`EndDate=${filter.endDate}`);
  filter.movementType && arrayQueryParams.push(`MovementType=${filter.movementType}`);
  filter.searchKey && arrayQueryParams.push(`SearchKey=${filter.searchKey}`);
  filter.storeId && arrayQueryParams.push(`StoreId=${filter.storeId}`);
  return arrayQueryParams.length > 0 ?  `${fmsDotUrl}/Movement/GetReport?${arrayQueryParams.join("&")}`: `${fmsDotUrl}/Movement/GetReport`
}